module.exports = __webpack_public_path__ + "static/img/invoice-document-vertical.042e5aba.svg";